import { stringHasValue } from '../stringHasValue/stringHasValue';

export const sentenceCase = (str: string) => {
  if (!stringHasValue(str)) return '';
  return str
    .toLowerCase()
    .replace(/^(.)/, (match, firstLetter) => firstLetter.toUpperCase());
};
